import PropTypes from 'prop-types';
import styled from 'styled-components';
import Config from '../../config';

const Row = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  flex-direction: ${p => (p.reverse ? 'row-reverse' : 'row')};
  ${p =>
    p.start &&
    Config.media[p.start]`
    justify-content: flex-start;
    text-align: start;
  `} ${p =>
  p.center &&
  Config.media[p.center]`
    justify-content: center;
    text-align: center;
  `} ${p =>
  p.end &&
  Config.media[p.end]`
    justify-content: flex-end;
    text-align: end;
  `} ${p =>
  p.top &&
  Config.media[p.top]`
    align-items: flex-start;
  `} ${p =>
  p.middle &&
  Config.media[p.middle]`
    align-items: center;
  `} ${p =>
  p.bottom &&
  Config.media[p.bottom]`
    align-items: flex-end;
  `} ${p =>
  p.around &&
  Config.media[p.around]`
    justify-content: space-around;
  `} ${p =>
  p.between &&
  Config.media[p.between]`
    justify-content: space-between;
  `};
`;

Row.propTypes = {
  /** Reverse flex direction */
  reverse: PropTypes.bool,
  /** Start alignment */
  start: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Center alignment */
  center: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** End alignment */
  end: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Top alignment */
  top: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Middle alignment */
  middle: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Bottom alignment */
  bottom: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Around alignment */
  around: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** Between alignment */
  between: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};

/** @component */
export default Row;
